import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrow180 = () => {
  return (
    <g>
      <path d="m15.7941 11.7632c-.0051-.012-.0153-.0206-.0209-.0322a.7353.7353 0 0 0 -.13-.2017l-2.2046-2.2632a.75.75 0 0 0 -1.0742 1.0469l.9645.99h-7.34a4.342 4.342 0 1 1 0-8.6841h9.1094a.75.75 0 0 0 0-1.5h-9.1089a5.842 5.842 0 1 0 0 11.6841h7.2892l-.8039.794a.75.75 0 0 0 1.0547 1.0674l2.1035-2.0781a.7475.7475 0 0 0 .1612-.8231z" />
    </g>
  );
};

export default withIcon(IconArrow180);
